<script>
  // import { onMount } from "svelte"
  //  import { fade, fly } from "svelte/transition"

  //  import { db, firebaseFunctions } from "../etc/firebase.js"
  import { db } from "../etc/firebase.js"
  import {
    userStore,
    guaRecordStore,
    newsListStore,
    selectedLanguage,
  } from "../etc/store.js"
  import marked from "marked"
  import {
    formatDate,
    btn_style_yellow_d3,
    btn_style_blue_d2,
    btn_style_orange_d2,
  } from "../etc/helpers.js"

  let guaCount30Days = 0
  let newsList
  let remainingDays = 0
  let btn_style = "btn waves-effect waves-light btn-big"
  let memberFeature = "（會員功能）"

  // The epoch time in 30 days ago
  let dt = Date.now()
  let day30 = dt - 1000 * 60 * 60 * 24 * 30
  let guaRecordStoreObj = []

  // *** Getting News for guests and members
  //let newsList = [{ title: "No News at the moment.", content: "" }]
  let newsCount = 0
  // Only collect published news items
  function loadNews() {
    //console.log("@ Nav: just got in loadNews")

    db.collection("notes")
      .where("published", "==", true)
      .get()
      .then((querySnapshot) => {
        //newsList = []
        querySnapshot.forEach((doc) => {
          // doc.data() is never undefined for query doc snapshots
          newsCount++
          newsList.push(doc.data())
          //console.log("@ Nav - title: ", doc.data().title)
          //console.log("@ Nav - 1st then content: ", doc.data().content)
        })
      })
      .then(() => {
        // console.log("@ Nav: 2nd then, published news count = " + newsCount)
        // console.log("@ Nav: 2nd then, newsList = " + newsList)
        newsList.sort((a, b) => (a.updatedDT < b.updatedDT ? 1 : -1))
        // $userStore.newsList = [...newsList]
        $newsListStore = JSON.stringify(newsList)
        // console.log(
        //   "@ Nav: in loadNews $newsListStore = ",
        //   JSON.parse($newsListStore)
        // )

        newsList = [...JSON.parse($newsListStore)]

        if (newsList == undefined) {
          newsList = [{ title: "No News at the moment.", content: "" }]
        }
      })
      .catch(function (error) {
        console.error(error)
      })
  }
  // === End getting news

  // onMount(async () => {
  $: if ($userStore.isLogin == true) {
    // console.log(
    //   "@ Home.$: checked $userStore.isLogin is true. About to get remainingDays and localStorage $guaRecordStore"
    // )

    // if ($userStore.isLogin == true) {
    // newsList = [...$userStore.newsList]
    //console.log("@ Home: $newsListStore = ", JSON.parse($newsListStore))
    // newsList = [...JSON.parse($newsListStore)]
    remainingDays = $userStore.userInfo.timeToExpiration

    // console.log(
    //   "@ Home.in $: if $userStore.isLogin. typeof $guaRecordStore is ",
    //   typeof $guaRecordStore
    // )
    if ($guaRecordStore.length != 0) {
      // console.log(
      //   "@ Home, JSON.parse($guaRecordStore) = ",
      //   JSON.parse($guaRecordStore)
      // )

      guaRecordStoreObj = JSON.parse($guaRecordStore)

      // console.log("@ Home, now guaRecordStoreObj is = ", guaRecordStoreObj)
    } else {
      // console.log(
      //   "@ Home.in $: if $userStore.isLogin. $guaRecordStore is empty"
      // )
    }
    //$userStore.guaRecords.forEach((item) => {
    guaCount30Days = 0
    guaRecordStoreObj.forEach((item) => {
      if (item.recordDT >= day30) {
        guaCount30Days++
      }
    })
    // console.log("@ Home - guaCount30Days: ", guaCount30Days)
    // console.log("@ Home - remainingDays is " + remainingDays)
  } else {
    // newsList = [...$userStore.newsList]
    // console.log("@ Home: not loging newsList = ", newsList)
    // console.log(
    //   "@ Home: user not loging! userStore.isLogin = " + $userStore.isLogin
    // )
  }
  // })

  $: if (newsList == null) {
    newsList = []
    loadNews()
    // newsList = [...JSON.parse($newsListStore)]

    // if (newsList.length == 0) {
    //   newsList = [{ title: "No News at the moment.", content: "" }]
    // }
  }

  function backToTop() {
    // Auto scroll back to the top of the page
    requestAnimationFrame(() => window.scrollTo(0, 0))
  }

  let showNewsItem = [false, false, false, false, false]
  function handleShowNews(news, i) {
    // console.log("@ Home: show news : " + news.content)
    showNewsItem[i] = !showNewsItem[i]
  }

  function handleCloseNews(i) {
    showNewsItem[i] = false
  }

  const goToAccountPage = () => {
    location.assign("/account")
  }

  // let onLoad = false
  //onMount(() => {
  //   setTimeout(() => (onLoad = true), 500)
  // })

  // function handleCloudFunction() {
  //   // get function reference
  //   const sayHello = firebaseFunctions.httpsCallable("sayHello")
  //   sayHello().then((result) => {
  //     console.log("Got cloud function return value = ", result)
  //   })
  // }
</script>

<!-- {#if onLoad}
  <div class="load" transition:fade> -->
{#if $selectedLanguage == "TW"}
  <main>
    <div class="card-panel indigo lighten-3">
      <h5 class="white-text">
        謝謝{$userStore.isLogin
          ? " " + $userStore.userInfo.userName + " 回到"
          : "您來到"}【XiYi習易網】
      </h5>
      <!-- <button on:click={handleCloudFunction}>Click Me</button> -->
      <p class="white-text">
        {#if $userStore.isLogin}
          您自訂的每個月起卦目標是【{$userStore.userInfo.qiMonthlyGoal}】次。
          過去30天裡，您總共起卦【{guaCount30Days}】次。{guaCount30Days >=
          $userStore.userInfo.qiMonthlyGoal
            ? "恭喜達標！"
            : "加油！"}
          <br />
          {#if remainingDays >= 60}
            <div class="btn-row center">
              <a href="/demo" class={btn_style_yellow_d3}>會員功能示範</a>
            </div>
          {/if}
        {:else}
          目前本站不對外開放。
        {/if}
      </p>
      {#if $userStore.isLogin && remainingDays < 0}
        <div class="center red lighten-5 red-text sub-warning">
          <div class="highlight lime accent-1">
            <h5>*** 提醒您 ***</h5>
            <h6>
              您的會員身分已經在 {Math.abs(
                Math.round((remainingDays + Number.EPSILON) * 100) / 100
              )} 天前過期了。如果您還願意繼續使用【YiXi 習易網】，請續訂，謝謝！
            </h6>
          </div>
          <br />
          <div class="btn-row center">
            <a href="/demo" class={btn_style_yellow_d3}>會員功能示範</a>
            <button
              on:click={goToAccountPage}
              class={btn_style_blue_d2 + " btn-large"}>我要續訂</button
            >
          </div>
        </div>
      {:else if $userStore.isLogin && remainingDays < 60}
        <div class="center indigo lighten-5 indigo-text sub-warning">
          <div class="highlight lime accent-1">
            <h5>*** 提醒您 ***</h5>
            <h6>
              您的會員身分將在 {Math.round(
                (remainingDays + Number.EPSILON) * 100
              ) / 100} 天後到期。如果您還要繼續使用【YiXi 習易網】，請擇期續訂，謝謝！
            </h6>
          </div>
          <br />
          <div class="btn-row center">
            <a href="/demo" class={btn_style_yellow_d3}>會員功能示範</a>
            <button on:click={goToAccountPage} class={btn_style_blue_d2}
              >我要續訂</button
            >
          </div>
        </div>
      {/if}
    </div>

    <!-- Frequently Used Features Here -->
    <h5 class="center">常用功能連結</h5>

    <div class="fu-set">
      <!-- <div class="fu" style="display:{$userStore.isLogin ? 'none' : 'block'}">
        <a href="/demo" class={btn_style + " indigo accent-1"}>使用簡介</a>
      </div> -->
      <div class="fu">
        <a
          on:click={backToTop}
          href="/books"
          class={btn_style + " light-blue darken-1"}>古籍</a
        >
      </div>
      <div class="fu">
        <a
          on:click={backToTop}
          href={$userStore.isLogin && !$userStore.isExpired ? "/play" : "#"}
          class={$userStore.isLogin && !$userStore.isExpired
            ? btn_style + " yellow darken-3"
            : btn_style + " grey-text blue-grey lighten-3"}
          >玩卦{$userStore.isLogin && !$userStore.isExpired
            ? ""
            : memberFeature}</a
        >
      </div>
      <div class="fu">
        <a
          on:click={backToTop}
          href={$userStore.isLogin && !$userStore.isExpired ? "/qi" : "#"}
          class={$userStore.isLogin && !$userStore.isExpired
            ? btn_style + " cyan darken-1"
            : btn_style + " grey-text blue-grey lighten-3"}
          >起卦{$userStore.isLogin && !$userStore.isExpired
            ? ""
            : memberFeature}</a
        >
      </div>
      <div class="fu">
        <a
          on:click={backToTop}
          href={$userStore.isLogin && !$userStore.isExpired ? "/records" : "#"}
          class={$userStore.isLogin && !$userStore.isExpired
            ? btn_style + " deep-purple accent-1"
            : btn_style + " grey-text blue-grey lighten-3"}
          >卦例{$userStore.isLogin && !$userStore.isExpired
            ? ""
            : memberFeature}</a
        >
      </div>
    </div>
    <br />
    <!-- Latest News Begin Here -->
    <div>
      <h5 class="news-h5 center">最新消息</h5>
      <div class="card indigo lighten-4 card-content">
        <div class="card-body news-content">
          <table class="striped home-news">
            <thead class=" news-rows">
              <tr
                class="news-hd news-row white-text"
                style="background-color: #5c6bc0;"
              >
                <th>日期 </th>
                <th>標題 </th>
              </tr>
            </thead>

            <tbody>
              <!-- {#if newsList != null} -->
              {#each newsList as news, i}
                <tr
                  class="news-item news-row"
                  on:click={() => handleShowNews(news, i)}
                >
                  <td><strong> {formatDate(news.updatedDT)}</strong></td>
                  <td
                    ><strong>{news.title}</strong>
                    <div
                      class=" news-content"
                      style="display: {showNewsItem[i] ? 'block' : 'none'}"
                    >
                      {@html marked(news.content)}
                      <br />
                      <hr />
                      <button
                        class={btn_style_orange_d2}
                        on:click={handleCloseNews}>關閉</button
                      >
                    </div>
                  </td>
                </tr>
              {/each}
              <!-- {/if} -->
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <br />
  </main>
{:else}
  <main>
    <div class="card-panel indigo lighten-3">
      <h5 class="white-text">
        谢谢{$userStore.isLogin
          ? " " + $userStore.userInfo.userName + " 回到"
          : "您来到"}【XiYi习易网】
      </h5>
      <p class="white-text">
        {#if $userStore.isLogin}
          您自订的每个月起卦目标是【{$userStore.userInfo.qiMonthlyGoal}】次。
          过去30天里，您总共起卦【{guaCount30Days}】次。{guaCount30Days >=
          $userStore.userInfo.qiMonthlyGoal
            ? "恭喜达标！"
            : "加油！"}
          <br />
          {#if remainingDays >= 60}
            <div class="btn-row center">
              <a href="/demo" class={btn_style_yellow_d3}>会员功能示范</a>
            </div>
          {/if}
        {:else}
          目前本站不对外开放。
        {/if}
      </p>
      {#if $userStore.isLogin && remainingDays < 0}
        <div class="center red lighten-5 red-text sub-warning">
          <div class="highlight lime accent-1">
            <h5>*** 提醒您 ***</h5>
            <h6>
              您的会员身分已经在 {Math.abs(
                Math.round((remainingDays + Number.EPSILON) * 100) / 100
              )} 天前过期了。如果您还愿意继续使用【YiXi 习易网】，请续订，谢谢！
            </h6>
          </div>
          <br />
          <div class="btn-row center">
            <a href="/demo" class={btn_style_yellow_d3}>会员功能示范</a>
            <button
              on:click={goToAccountPage}
              class={btn_style_blue_d2 + " btn-large"}>我要续订</button
            >
          </div>
        </div>
      {:else if $userStore.isLogin && remainingDays < 60}
        <div class="center indigo lighten-5 indigo-text sub-warning">
          <div class="highlight lime accent-1">
            <h5>*** 提醒您 ***</h5>
            <h6>
              您的会员身分将在 {Math.round(
                (remainingDays + Number.EPSILON) * 100
              ) / 100} 天后到期。如果您还要继续使用【YiXi 习易网】，请择期续订，谢谢！
            </h6>
          </div>
          <br />
          <div class="btn-row center">
            <a href="/demo" class={btn_style_yellow_d3}>会员功能示范</a>
            <button on:click={goToAccountPage} class={btn_style_blue_d2}
              >我要续订</button
            >
          </div>
        </div>
      {/if}
    </div>

    <!-- Frequently Used Features Here -->
    <h5 class="center">常用功能连结</h5>

    <div class="fu-set">
      <!-- <div class="fu" style="display:{$userStore.isLogin ? 'none' : 'block'}">
        <a href="/demo" class={btn_style + " indigo accent-1"}>使用简介</a>
      </div> -->
      <div class="fu">
        <a
          on:click={backToTop}
          href="/books"
          class={btn_style + " light-blue darken-1"}>古籍</a
        >
      </div>
      <div class="fu">
        <a
          on:click={backToTop}
          href={$userStore.isLogin && !$userStore.isExpired ? "/play" : "#"}
          class={$userStore.isLogin && !$userStore.isExpired
            ? btn_style + " yellow darken-3"
            : btn_style + " grey-text blue-grey lighten-3"}
          >玩卦{$userStore.isLogin && !$userStore.isExpired
            ? ""
            : memberFeature}</a
        >
      </div>
      <div class="fu">
        <a
          on:click={backToTop}
          href={$userStore.isLogin && !$userStore.isExpired ? "/qi" : "#"}
          class={$userStore.isLogin && !$userStore.isExpired
            ? btn_style + " cyan darken-1"
            : btn_style + " grey-text blue-grey lighten-3"}
          >起卦{$userStore.isLogin && !$userStore.isExpired
            ? ""
            : memberFeature}</a
        >
      </div>
      <div class="fu">
        <a
          on:click={backToTop}
          href={$userStore.isLogin && !$userStore.isExpired ? "/records" : "#"}
          class={$userStore.isLogin && !$userStore.isExpired
            ? btn_style + " deep-purple accent-1"
            : btn_style + " grey-text blue-grey lighten-3"}
          >卦例{$userStore.isLogin && !$userStore.isExpired
            ? ""
            : memberFeature}</a
        >
      </div>
    </div>
    <br />
    <!-- Latest News Begin Here -->
    <div>
      <h5 class="news-h5 center">最新消息</h5>
      <div class="card indigo lighten-4 card-content">
        <div class="card-body news-content">
          <table class="striped home-news">
            <thead class=" news-rows">
              <tr
                class="news-hd news-row white-text"
                style="background-color: #5c6bc0;"
              >
                <th>日期 </th>
                <th>标题 </th>
              </tr>
            </thead>

            <tbody>
              <!-- {#if newsList != null} -->
              {#each newsList as news, i}
                <tr
                  class="news-item news-row"
                  on:click={() => handleShowNews(news, i)}
                >
                  <td><strong> {formatDate(news.updatedDT)}</strong></td>
                  <td
                    ><strong>{news.title}</strong>
                    <div
                      class=" news-content"
                      style="display: {showNewsItem[i] ? 'block' : 'none'}"
                    >
                      {@html marked(news.content)}
                      <br />
                      <hr />
                      <button
                        class={btn_style_orange_d2}
                        on:click={handleCloseNews}>关闭</button
                      >
                    </div>
                  </td>
                </tr>
              {/each}
              <!-- {/if} -->
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <br />
  </main>
{/if}
<!-- </div> -->
<!-- {:else} -->
<!-- <div class="loading white-text indigo darken-1">
    <h1 class="center">【XiYi習易網】 載入中···</h1>
  </div> -->

<!-- {/if} -->
<style>
  .card-content {
    padding: 0px;
  }
  .news-content {
    padding-left: 0px !important;
  }
  .home-news {
    padding: 0px;
  }

  .sub-warning {
    padding: 10px;
  }
  .news-content {
    padding-left: 10px;
    /* background-color: #eeeeee; */
  }
  .news-h5 {
    padding-bottom: 15px;
  }
  .news-row {
    display: grid;
    grid-template-columns: 1fr 4fr;
    padding-left: 15px;
    padding-right: 20px;
    border-bottom: #7986cb solid 2px;
  }
  .news-item:hover {
    cursor: pointer;
  }
  .fu-set {
    display: flex;
    flex-wrap: wrap;
    /* grid-gap: 15px; */
    width: 100%;
    justify-content: center;
  }

  .fu a {
    font-size: large;
    padding-top: 32px;
  }
  .btn-big {
    min-width: 150px;
    height: 60px;
    margin-top: 10px;
    margin-right: 10px;
    line-height: 0px;
  }
  .btn-single {
    margin-bottom: 10px;
  }
  li {
    list-style-type: square !important;
  }
  .btn-row {
    margin-top: 20px;
  }
  .btn-row a {
    margin-right: 20px;
  }
  /* .home-img {
    width: 100%;
  } */
  .highlight {
    padding-top: 10px;
    padding-bottom: 10px;
  }
  .loading {
    width: 100%;
    height: 1000px;
    padding-top: 300px;
    font-size: 1000;
    font-weight: 800;
  }
</style>
